import React from 'react';

export interface IconProps {
  size?: number;
  color?: string;
  className?: string;
}

// Track Temperature - checkered flag (motorsport-specific, not available in Weather Icons)
// Uses 30x30 viewBox like Weather Icons to match visual proportions
export const TrackTempIcon: React.FC<IconProps> = ({ size = 16, color = 'currentColor', className }) => (
  <svg width={size} height={size} viewBox="0 0 30 30" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <g transform="translate(5, 4)">
      <path d="M3 13s1-1 4-1 5 2 8 2 4-1 4-1V2s-1 1-4 1-5-2-8-2-4 1-4 1z"/>
      <line x1="3" y1="19" x2="3" y2="13"/>
      <rect x="5" y="4" width="2.5" height="2.5" fill={color} stroke="none"/>
      <rect x="10" y="4" width="2.5" height="2.5" fill={color} stroke="none"/>
      <rect x="7.5" y="6.5" width="2.5" height="2.5" fill={color} stroke="none"/>
      <rect x="12.5" y="6.5" width="2.5" height="2.5" fill={color} stroke="none"/>
    </g>
  </svg>
);
